<template>
    <div class="container">
        <div class="aboutmain">
            <div class="row">
                <div class="col-md-12">
                    <h2><b>Panjabi</b> Collection's</h2>
                    <div id="myCarousel" class="carousel slide" data-ride="carousel" data-interval="0">
                    <!-- Carousel indicators -->  
                    <!-- Wrapper for carousel items -->
                    <div class="carousel-inner">
                        <div class="item active">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-1.jpg" class="img-responsive" alt="">									
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Vertical Striper on Sleeves</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳2799.00</strike> <b>৳2099.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-2.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Ball Printed Regular</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1800.00</strike> <b>৳1200.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>		
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-3.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Slim Fit Cotton Panjabi</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1850.00</strike> <b>৳1350.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>								
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-4.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Embroidered on Neck</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳2900.00</strike> <b>৳2300.99</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-5.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Textured Black</h4>
                                            <p class="item-price"><strike>৳1850.00</strike> <span>৳1550.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-6.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Textured Eid Panjabi</h4>
                                            <p class="item-price"><strike>৳1550.99</strike> <span>৳1299.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-7.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Men with neck work</h4>
                                            <p class="item-price"><strike>৳2200.00</strike> <span>৳1800.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-8.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Textured Eid Panjabi</h4>
                                            <p class="item-price"><strike>৳1950.00</strike> <span>৳1670.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>						
                            </div>
                        </div>
                        <div class="item">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-9.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Embroidered on Neck</h4>
                                            <p class="item-price"><strike>৳1899.00</strike> <span>৳1550.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-10.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Vertical Striped Cotton</h4>
                                            <p class="item-price"><strike>৳2100.00</strike> <span>৳1900.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-11.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Textured Eid Panjabi</h4>
                                            <p class="item-price"><strike>৳1699.00</strike> <span>৳1299.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>	
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-12.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Pattern Printed</h4>
                                            <p class="item-price"><strike>৳2150.00</strike> <span>৳1850.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>



                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-13.jpg" class="img-responsive" alt="">									
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Pattern Printed</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1999.00</strike> <b>৳1650.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-14.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Vertical Striped</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1899.00</strike> <b>৳1500.99</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>		
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-15.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Embroidered on Neck</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳2200.00</strike> <b>৳1800.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>								
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-16.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Nicely Worked With Karchupi</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1900.00</strike> <b>৳1700.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div class="item">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-17.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Vertical Striped Cotton</h4>
                                            <p class="item-price"><strike>৳2350.00</strike> <span>৳2100.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-18.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Pattern Printed</h4>
                                            <p class="item-price"><strike>৳1800.00</strike> <span>৳1650.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-19.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Textured Eid Panjabi</h4>
                                            <p class="item-price"><strike>৳1700.00</strike> <span>৳1550.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-20.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Textured Eid Panjabi</h4>
                                            <p class="item-price"><strike>৳2050.00</strike> <span>৳1800.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>						
                            </div>
                        </div>
                        <div class="item">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-21.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Lightweight soft cotton</h4>
                                            <p class="item-price"><strike>৳1900.00</strike> <span>৳1600.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-22.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Embroidered on Neck</h4>
                                            <p class="item-price"><strike>৳1850.00</strike> <span>৳1550.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-23.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Pattern Printed</h4>
                                            <p class="item-price"><strike>৳2080.00</strike> <span>৳1950.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>	
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/panjabi-24.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Long Vertical Striped</h4>
                                            <p class="item-price"><strike>৳1880.00</strike> <span>৳1450.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Carousel controls -->
                    
                </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'PanjabiCompo'
    }
</script>

<style  scoped>
    .col-sm-3{
        text-align: center;
        margin: 20px auto;
    }
    .thumb-wrapper{
        margin: 0 auto;
        width: 80%;
        box-shadow: 0 4px 8px 0 rgba(50, 50, 50, 0.2), 0 6px 20px 0 rgba(220, 220, 220, 0.19);
        border-radius: 10px;
    }
    img{
        width: 220px;
    }
    a{
        margin: 20px auto;
    }
    h4{
        font-size: 16px;
    }
    .btn:hover{
        opacity: 0.7;
        transition: all 0.2s ease-in-out;
    }
</style>
